import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import Drawer from 'components/AntEnhancement/Drawer';
import DocumentForm from 'components/forms/accounting/documents/DocumentForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { Document } from 'models';
import services from 'services';
import './DocumentDrawer.css';
var DocumentDrawer = function (props) {
    var visiable = props.visiable, onCloseDrawer = props.onCloseDrawer, t = props.translate;
    var document = useState(function () { return new Document(); })[0];
    var _a = useState(false), saving = _a[0], setSaving = _a[1];
    var form = Form.useForm()[0];
    var documentService = services.documentService;
    var createDocument = documentService.useCreateDocument().mutate;
    useEffect(function () {
        if (!visiable)
            return;
        document.setName('');
        form.resetFields();
        setSaving(false);
    }, [visiable, document, form]);
    var onSubmit = function () {
        if (saving)
            return;
        document.setName((document.getName() || '').trim());
        setSaving(true);
        createDocument({ document: document, successMessage: t('documentCreated') }, {
            onSuccess: function () {
                setSaving(false);
                onCloseDrawer();
            },
            onError: function () { return setSaving(false); }
        });
    };
    return (_jsx(Drawer, { title: null, placement: "right", open: visiable, onClose: onCloseDrawer, closable: false, destroyOnClose: true, width: 440, rootClassName: "doc-drawer", className: "doc-drawer", children: _jsxs(Form, { form: form, layout: "vertical", className: "doc-drawer__shell", requiredMark: false, onFinish: onSubmit, children: [_jsxs("header", { className: "doc-drawer__header", children: [_jsxs("div", { className: "doc-drawer__title-block", children: [_jsx("span", { className: "doc-drawer__dot", "aria-hidden": true }), _jsxs("div", { children: [_jsx("h2", { className: "doc-drawer__title", children: t('title') }), _jsx("p", { className: "doc-drawer__subtitle", children: t('subtitle') })] })] }), _jsx("button", { type: "button", className: "doc-drawer__close", onClick: onCloseDrawer, "aria-label": t('common:buttons.close'), children: _jsx(CloseOutlined, {}) })] }), _jsx("div", { className: "doc-drawer__body", children: _jsx(DocumentForm, { document: document }) }), _jsxs("footer", { className: "doc-drawer__footer", children: [_jsx("button", { type: "button", className: "doc-drawer__btn doc-drawer__btn--ghost", onClick: onCloseDrawer, children: t('common:buttons.cancel') }), _jsxs("button", { type: "submit", className: "doc-drawer__btn doc-drawer__btn--primary", disabled: saving, children: [_jsx(CheckOutlined, {}), _jsx("span", { children: saving ? t('saving') : t('common:buttons.submit') })] })] })] }) }));
};
export default localeTranslator(DocumentDrawer, 'documentForm');
